// @flow

import * as analysis from '../analysis'

let isRnReady = false
let messageQuene: Array<string> = []

function appShareAnalytics (opts) {
  let suc = opts.success
  let failure = opts.failure

  opts.success = getFnName(function () {
    suc && suc instanceof Function && suc()
    analysis.trackEventValue('app-share-success', {
      url: opts.link
    })
  })
  opts.failure = getFnName(function () {
    failure && failure instanceof Function && failure()
    analysis.trackEventValue('app-share-cancel', {
      url: opts.link
    })
  })
}

function getFnName (callback?: Function): string {
  let fnName =
    'fn_' + parseInt(Math.random() * 10000, 10) + '_' + new Date().getTime()
  window[fnName] = typeof callback === 'function' ? callback : function () {}
  return fnName
}

function postMessage (method: string, ...args: Array<any>) {
  const message = JSON.stringify({ method, args })
  if (isRnReady) {
    window.postMessage(message)
  } else {
    messageQuene.push(message)
  }
}

document.addEventListener('message', function (e) {
  if (e.data === 'rnWebReady') {
    isRnReady = true
    messageQuene.forEach(message => {
      window.postMessage(message)
    })
    messageQuene = []
  }
})

export function initPage () {
  postMessage('initPage')
}

export function setPageTitle (title: string) {
  postMessage('setPageTitle', title)
}

export function setPageDefaultTitle (title: string) {
  postMessage('setPageDefaultTitle', title)
}

export function closeToRoot () {
  postMessage('closeCurrentPushPage')
}

export function close () {
  postMessage('closeCurrentPushPage')
}

type NavBarConfig = {
  text: string,
  image: string,
  clickCallback: Function
};

export function setNavigationBarRightButton (navBarConfig: NavBarConfig) {
  postMessage('setNavigationBarRightButton', {
    text: navBarConfig.text,
    image: navBarConfig.image,
    clickCallback: getFnName(navBarConfig.clickCallback)
  })
}

type ShareInfo = {
  title: string,
  imgUrl: string,
  desc: string,
  link: string,
  failure?: () => void,
  success?: () => void
};

export function share (shareInfo: ShareInfo) {
  let opts = { ...shareInfo }
  appShareAnalytics(opts)
  postMessage('share', opts)
}

export function showShareButton (shareInfo: ShareInfo) {
  let opts = { ...shareInfo }
  if (/^[/][/]/.test(opts.imgUrl)) {
    opts.imgUrl = opts.imgUrl.replace(/^[/][/]/, 'http://')
  }
  appShareAnalytics(opts)
  postMessage('showShareButton', opts)
}

export function hiddenShareButton () {
  postMessage('hideNavigationBarRightButton')
}

export function login (success: Function, cancel?: Function) {
  getUser(function (userinfo) {
    if (userinfo.isLogin) {
      return success()
    }
    if (typeof cancel === 'function') {
      postMessage('login', getFnName(success), getFnName(cancel))
    } else {
      postMessage('login', getFnName(success))
    }
  })
}

export function getUser (callback: Function) {
  postMessage('getUser', getFnName(callback))
}

export function toPageRouter (url: string, replace?: boolean) {
  let routerOpts = { url, finish: !!replace }
  postMessage('toPageRouter', routerOpts)
}



// WEBPACK FOOTER //
// ./src/frame/core/app/ydd.js